var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7474,
    cy: 20,
    rx: 19.9861,
    ry: 20,
    fill: "#005CE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0719 13.2521C31.1986 13.6387 30.2725 13.8925 29.3242 14.0053C30.3237 13.4071 31.0718 12.4657 31.429 11.3565C30.491 11.9151 29.4626 12.3066 28.3908 12.5184C27.6708 11.7475 26.7166 11.2363 25.6763 11.0641C24.636 10.892 23.5681 11.0686 22.6385 11.5665C21.7088 12.0644 20.9697 12.8557 20.5358 13.8174C20.102 14.779 19.9978 15.8572 20.2394 16.8842C18.3372 16.7888 16.4764 16.2942 14.7776 15.4324C13.0789 14.5706 11.5803 13.3609 10.379 11.8819C9.95385 12.6128 9.73041 13.4435 9.7316 14.2892C9.7316 15.949 10.5758 17.4154 11.8592 18.2739C11.0997 18.2499 10.3569 18.0447 9.69271 17.6752V17.7347C9.69294 18.8401 10.0752 19.9115 10.7747 20.7671C11.4741 21.6227 12.4478 22.2099 13.5305 22.4291C12.8254 22.6203 12.0861 22.6485 11.3685 22.5115C11.6738 23.463 12.2688 24.2952 13.0702 24.8914C13.8716 25.4877 14.8392 25.8183 15.8377 25.8368C14.8454 26.6167 13.7091 27.1933 12.494 27.5334C11.2788 27.8736 10.0086 27.9708 8.75586 27.8194C10.9426 29.2267 13.4883 29.9739 16.0882 29.9714C24.8882 29.9714 29.7006 22.6763 29.7006 16.3496C29.7006 16.1436 29.6948 15.9353 29.6857 15.7315C30.6224 15.054 31.4308 14.2148 32.073 13.2533L32.0719 13.2521Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.b2abb2780d1acdccaa86efd875e75d69.svg";
export { ForwardRef as ReactComponent };